/* eslint-disable import/prefer-default-export */
// 根据level获取vip角标图片
export var VIPICON = {
  1: 'https://puui.qpic.cn/vupload/0/20190428_VIP_1_2x.png/0',
  2: 'https://puui.qpic.cn/vupload/0/20190428_VIP_2_2x.png/0',
  3: 'https://puui.qpic.cn/vupload/0/20190428_VIP_3_2x.png/0',
  4: 'https://puui.qpic.cn/vupload/0/20190428_VIP_4_2x.png/0',
  5: 'https://puui.qpic.cn/vupload/0/20190428_VIP_5_2x.png/0',
  6: 'https://puui.qpic.cn/vupload/0/20190428_VIP_6_2x.png/0',
  7: 'https://puui.qpic.cn/vupload/0/20190428_VIP_7_2x.png/0',
  8: 'https://vfiles.gtimg.cn/vupload/20200616/c2756a1592295933410.png'
};
export var NUMPIC = {
  1: 'https://vfiles.gtimg.cn/vupload/202006/22b9fc1591349990487.png',
  2: 'https://vfiles.gtimg.cn/vupload/202006/d0f87d1591350471893.png',
  3: 'https://vfiles.gtimg.cn/vupload/202006/dbf0d61591350541116.png',
  4: 'https://vfiles.gtimg.cn/vupload/202006/bbc64c1591350607989.png',
  5: 'https://vfiles.gtimg.cn/vupload/202006/fc5f211591350690123.png',
  6: 'https://vfiles.gtimg.cn/vupload/202006/9c24781591350711761.png'
};
export default {
  VIPICON: VIPICON
};